/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../../Shared/Card'
import { Icon, Label, List, ListItem, Popup, PopupContent, Rating, Image } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { THEME_COLORS } from '../../../../Shared/theme'

const IntegrationStateCard = ({integrationState}) => {
    const [t] = useTranslation()

    const getBorderColor = () => {
        switch (integrationState.status) {
            case 'OPEN':
                return THEME_COLORS.GREEN
            case 'PARTIALLY_OPEN':
                return '#e1731d'
            case 'CLOSED':
                return THEME_COLORS.RED
            case 'NO_DATA':
                return 'grey'
            default:
                return 'grey'
        }
    }

    const isAndroidDevice = () => {
        return (window.Android && window.Android.getToken)
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};

            .card-content {
                width: 265px;
                height: 110px;
        `}
      >
          <CardContent>
              <div css={css`
                  padding: 12px 16px;
                  border-bottom: 1px solid #e8e8e8;
                  display: grid;
                  grid-template-columns: 1fr auto;
                  grid-template-rows: auto auto;
                  grid-template-areas:
        "platform status"
        "platform rating";
                  gap: 1rem;

                  &:last-child {
                      border-bottom: none;
                  }
              `}>
                  <div css={css`
                      grid-area: platform;
                      display: flex;
                      align-items: flex-start;
                      justify-content: flex-start;
                      column-gap: .5rem;
                      font-size: 16px;
                      font-weight: 600;
                      color: #333;
                  `}>
                      <Image
                        src={`/img/platforms/${integrationState.platformModule}.jpg`}
                        size="tiny"
                      />
                      {(integrationState.webUrl && !isAndroidDevice()) && (
                        integrationState.webUrl.length === 1 ? (
                          <a
                            href={integrationState.webUrl[0]}
                            target="_blank"
                            rel="noopener noreferrer"
                            css={css`
                                margin-top: -5px;
                            `}
                          >
                              <Icon name="external alternate" size="small" color="black"/>
                          </a>
                        ) : (
                          <Popup
                            trigger={
                                <span style={{cursor: 'pointer'}}>
                                          <Icon
                                            name="external alternate"
                                            size="small"
                                          />
                                        </span>
                            }
                            on="click"
                            position="bottom left"
                          >
                              <PopupContent>
                                  <List>
                                      {integrationState.webUrl.map((url, urlIndex) => (
                                        <ListItem
                                          key={urlIndex}
                                          as="a"
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                            Lien {urlIndex + 1}
                                        </ListItem>
                                      ))}
                                  </List>
                              </PopupContent>
                          </Popup>
                        )
                      )}
                  </div>

                  <div css={css`
                      grid-area: status;
                      display: flex;
                      align-items: flex-start;
                      justify-content: flex-end;
                  `}>
                      {integrationState.status !== 'NO_DATA' && (
                        <Label
                          size="small"
                          color={integrationState.status === 'OPEN' ? 'green' : integrationState.status === 'PARTIALLY_OPEN' ? 'orange' : 'red'}
                        >
                            {t(`pos_brand_platform.siteStatus.${integrationState.status.toLowerCase()}`)}
                        </Label>
                      )}
                  </div>

                  <div css={css`
                      grid-area: rating;
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                  `}>
                      {integrationState.rating > 0 && (
                        <>
                            <Rating
                              icon="star"
                              defaultRating={integrationState.rating}
                              maxRating={5}
                              size="small"
                              disabled
                            />
                            ({integrationState.rating.toFixed(1)})
                        </>
                      )}
                  </div>
              </div>
          </CardContent>
      </Card>
    )
}

export { IntegrationStateCard }
